import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  appBar: {
    boxShadow: "none",
    backgroundColor: "transparent",
  },
  addButton: {
    margin: 0,
  },
  deleteButton: {
    padding: 0,
  },
  container: {
    background: theme.palette.background.default,
  },
}));

export const useTabsStyles = makeStyles<Theme>((theme) => ({
  root: {
    borderRadius: 10,
    minHeight: 44,
  },
  flexContainer: {
    display: "inline-flex",
    position: "relative",
    zIndex: 1,
    "& .Mui-selected": {
      color: theme.palette.events.whiteTertiary,
      backgroundColor: theme.palette.events.blueSecondary,
      transition: "background-color 0.2s ease",
      "& svg": {
        fill: theme.palette.events.whiteTertiary,
      },
    },
  },
  scroller: {
    display: "flex",
    justifyContent: "center",
  },
  indicator: {
    top: 3,
    bottom: 3,
    right: 3,
    height: "auto",
    background: "none",
    "&:after": {
      content: '""',
      display: "block",
      position: "absolute",
      padding: "10px 0px",
      top: 0,
      left: 5,
      right: 5,
      bottom: 0,
      borderRadius: 100,
      backgroundColor: theme.palette.events.blueSecondary,
    },
  },
}));

export const useTabItemStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 100,
    "&:hover": {
      opacity: 1,
    },
    minHeight: 42,
    minWidth: 169,
    flexDirection: "row",
    color: theme.palette.icon.secondary,
    "& svg": {
      fill: theme.palette.icon.secondary,
    },
    textTransform: "initial",
    "& img": {
      marginRight: 5,
    },
    "& .MuiTab-iconWrapper": {
      marginBottom: "0px !important",
      marginRight: "10px",
    },
  },
}));
